(function() {
    const mainHeaderEl = document.querySelector('.jsMainHeader');

    if (mainHeaderEl) {
        const headroom = new Headroom(mainHeaderEl, {
            offset: 40,
            onPin: _ => document.body.classList.remove('header-unpinned'),
            onUnpin: _ => document.body.classList.add('header-unpinned')
        });

        headroom.init();
    }
})();